import { T as TabMenu, d as defineCustomElement$1 } from './p-BHlOKcck.js';

const WangsTabMenu = TabMenu;
const defineCustomElement = defineCustomElement$1;

export { WangsTabMenu, defineCustomElement };
